module.exports = __webpack_public_path__ + "static/media/2 (5).c8a664d1.jpg";